import Cookies from "js-cookie";
import { atom } from "recoil";

type TIsDark = "true" | "false";
type TLang = "en" | "tz" | "ko";
type TTheme = { isDark: TIsDark; lang: TLang };

const themeState = atom<TTheme>({
    key: "themeState",
    default: {
        isDark: (() => {
            let cookieValue = Cookies.get("isDark");
            switch (cookieValue) {
                case "true":
                case "false":
                    break;
                default:
                    Cookies.remove("isDark");
                    cookieValue = undefined;
                    break;
            }
            const mediaValue = window.matchMedia("(prefers-color-scheme: dark)").matches ? "true" : "false";
            return cookieValue ?? mediaValue;
        })(),
        lang: (() => {
            let cookieValue = Cookies.get("lang");
            switch (cookieValue) {
                case "en":
                case "ko":
                case "tz":
                    break;
                default:
                    Cookies.remove("lang");
                    cookieValue = undefined;
            }
            return cookieValue ?? "en";
        })(),
    },
    effects: [
        ({ onSet }) => {
            onSet((n, o: any) => {
                if (n.isDark !== o.isDark) {
                    Cookies.set("isDark", n.isDark);
                    if (n.isDark === "true") document.documentElement.classList.add("dark");
                    if (n.isDark === "false") document.documentElement.classList.remove("dark");
                }
                if (n.lang !== o.lang) {
                    Cookies.set("lang", n.lang);
                    document.documentElement.lang = n.lang;
                }
            });
        },
    ],
});

export default themeState;
